import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Input from "@mui/material/Input";

import { useDispatch, useSelector } from "react-redux";
import {
  addAdminNewsBanner,
  getAdminNewsBanner,
} from "../../../redux/admin/saga";
import { adminNewsBannerSelector } from "../../../redux/admin/selector";

const AdminNews = () => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState("");
  const [image, setImage] = useState();
  const [linkUrl, setLinkUrl] = useState("");
  const newsBanner = useSelector(adminNewsBannerSelector);
  const handleChangeImage = (event) => {
    const image = event.target.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = () => {
      setPreview(reader.result);
    };
    setImage(image);
  };

  const handleClickSave = () => {
    dispatch(
      addAdminNewsBanner({
        image,
        linkUrl,
      })
    );
  };

  useEffect(() => {
    dispatch(getAdminNewsBanner());
  }, [dispatch]);

  useEffect(() => {
    setLinkUrl(newsBanner.linkUrl);
  }, [newsBanner.linkUrl]);

  return (
    <>
      <TableContainer>
        <Table sx={{ minWidth: 650, marginTop: 2 }} aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell sx={{ width: "20%" }}>뉴스 배너 이미지</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  component="label"
                  sx={{ margin: "20px 20px 20px 0" }}
                >
                  이미지 변경
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={handleChangeImage}
                  />
                </Button>
                <br />
                {preview ? (
                  <img src={preview} alt="뉴스배너" />
                ) : newsBanner?.imageUrl ? (
                  <img src={newsBanner?.imageUrl} alt="뉴스배너" />
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "20%" }}>뉴스 배너 링크</TableCell>
              <TableCell>
                <Input
                  placeholder="https://를 포함한 전체 url을 입력해주세요."
                  fullWidth
                  value={linkUrl}
                  onChange={(event) => {
                    setLinkUrl(event.target.value);
                  }}
                />
              </TableCell>
            </TableRow>{" "}
            <TableRow sx={{ border: 0 }}>
              <TableCell colSpan={2} align="right" sx={{ border: 0 }}>
                <Button
                  variant="contained"
                  component="label"
                  onClick={handleClickSave}
                >
                  저장
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AdminNews;
